import { isAudioStation } from '../helpers';
import { useActiveStation } from './useActiveStation';

/**
 * Returns whether the currently active station is an audio station (non-video format).
 */
export function useIsActiveStationAudio() {
  return isAudioStation(useActiveStation());
}
